import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IAuthTable } from '../auth.interfaces';
import { authAdapter } from './approver-auth.reducer';

const {
    selectEntities: _selectApproveAuthEntities,
  } = authAdapter.getSelectors();

const selectApproverAuthSelector = createFeatureSelector<IAuthTable>('approverAuth');

export const selectDefaultApproverAuthEntity = id => createSelector(
    selectApproverAuthEntities,
    entities => entities[id]
);

export const selectApproverAuthEntities = createSelector(
    selectApproverAuthSelector,
    _selectApproveAuthEntities
  );
